module.exports = __webpack_public_path__ + "img/shoot_00041.1b354ccd.png";